import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * Hook for saving work history preferences
 * Updates bullet count preferences for multiple organizations in batch
 */
export const useSavePreferences = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: async (payload) => {
      const token = localStorage.getItem("token");

      console.log("💾 Saving Preferences:", payload);

      const response = await fetch("/api/work-history/preferences/batch", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Failed to save preferences");
      }

      const result = await response.json();
      console.log("✅ Preferences saved:", result);
      return result;
    },

    onSuccess: (data, variables) => {
      // Invalidate and refetch preferences
      queryClient.invalidateQueries({ queryKey: ["workHistoryPreferences"] });

      const count = variables.preferences?.length || 0;

      toast({
        title: "Preferences saved",
        description: `Updated settings for ${count} organization${count !== 1 ? 's' : ''}`,
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    },

    onError: (error) => {
      console.error("❌ Save preferences failed:", error);

      toast({
        title: "Save failed",
        description: error.message || "Failed to save preferences. Please try again.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    },

    retry: 1,
    retryDelay: 1000,
  });
};
